//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState, useEffect, useContext } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  IconButton,
} from '@mui/material';
import { Delete, DragHandle } from '@mui/icons-material';

// === COMPONENTS ===
import { ExpressionContext } from 'pages/DocAnalytics/RuleView/components/ExpressionContext/ExpressionContext';
import { FieldControls     } from './components/Field/FieldControls.jsx';
import { OperatorControls  } from './components/Operator/OperatorControls.jsx';
import { RecordControls    } from './components/Record/RecordControls.jsx';
import { ConstantControls  } from './components/Constant/ConstantControls.jsx';
import { SourceSelect      } from './components/SourceSelect/SourceSelect.jsx';
import { FunctionControls  } from './components/Function/FunctionControls.jsx';


//#endregion

//-----------------------------------------------------------------
export function Expression( props ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { id, data     } = props.data;
  const { is_predicate } = props;

  const theme = useTheme();

  const { removeExpression, removePredicate } = useContext( ExpressionContext );

  const [ source, setSource ] = useState(data?.source);

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: '100%',
      width: '100%',
      boxShadow: 0,
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
    },
    border_1: {
      display: 'grid', 
      gridTemplateColumns: 'auto auto 1fr',
      gridTemplateRows: '1fr',
      columnGap: '0.5rem',
      rowGap: '0.5rem',
      borderRadius: '1rem',
      padding: '1rem',
      width: 'calc( 100% )',
      backgroundColor: theme.palette.background.secondary[theme.palette.mode],
    },
    border_2: {
      border: 'solid ' + theme.palette.primary[theme.palette.mode],
      borderRadius: '1rem',
      padding: '1rem',
      width: '100%',
    },
    button_add: {
      backgroundColor: theme.palette.primary[theme.palette.mode],
      color: 'white'
    },
    button_remove: {
      width  : '3rem',
      height : '3rem',
      color: theme.palette.secondary.main,
    },
    icon: {
      'color' : 'green',
      'transform': 'rotate( 90deg )',
    },
  }

  const BORDER_1 = {
    style: _styles.border_1,
  };
  const BUTTON_DELETE = {
    sx: _styles.button_remove,
    onClick: onClick_Remove,
    children: <Delete />,
    name: 'da_remove_predicate_btn'
  };
  const BUTTON_DRAG = {
    sx: _styles.button_remove,
    children: <DragHandle />,
  };
  const ICON = {
    sx       : _styles.icon,
    fontSize : 'large',
  }
    
  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    setSource( data?.source )
  }, [data])

  //#endregion

  //#region [MODIFY]

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onClick_Remove( ) {
    //-----------------------------------------------------------------
    const remove = is_predicate ? removePredicate : removeExpression;
    remove( id );
  }
  
  //-----------------------------------------------------------------
  function onChange_Source( value ) {
    //-----------------------------------------------------------------
    setSource( value )
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div>
        <div { ...BORDER_1 } >
          {/* <IconButton { ...BUTTON_DRAG      } /> */}
          <IconButton { ...BUTTON_DELETE    } />
          <SourceSelect id={id} source={data?.source} onChange={onChange_Source} is_predicate={is_predicate} />
          { displayComponents() }
        </div>
      </div>
    );
  }

  //-----------------------------------------------------------------
  function displayComponents() {
    //-----------------------------------------------------------------
    if( source === 'FIELD' ) {
      return <FieldControls id={id} data={data} is_predicate={is_predicate} />
    }

    if( source === 'DOR' ) {
      return <RecordControls id={id} data={data} is_predicate={is_predicate} />;
    }

    if( source === 'OPERATOR' ) {
      return <OperatorControls id={id} data={data} is_predicate={is_predicate} />;
    }

    if( source === 'CONSTANT' ) {
      return <ConstantControls id={id} data={data} is_predicate={is_predicate} />;
    }

    if( source === 'FUNCTION' ) {
      return <FunctionControls id={id} data={data} is_predicate={is_predicate} />;
    }

  }

  //#endregion

  return display();
}
